import appConf from "../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];
const environment = process.env.NODE_ENV;
const project = "Registration Form";
const server = null;
const service = null;
const options = {
  preference_options: [
    { name: "Preference Type 1", value: "1" },
    { name: "Preference Type 2", value: "2" },
  ],
};
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    config: {
      api: {
        endpoints: {
          list: {
            headers: {
              "Content-Type": "application/json",
              Authorization: null,
            },
            doc: "https://tr4ns10.tr4ns.com/Westfield-Reporting",
            //url: "/Westfield-Reporting/report21?",
            url: setup.setup.api.tranxactor.url[environment] + "/configs",
            method: "GET",
          },
          create: {
            headers: {
              "Content-Type": "application/json",
              Authorization: null,
            },
            doc: "http://tr4ns10.tr4ns.com/Westfield-BulkOrder/auth/auth/token",
            url: setup.setup.api.tranxactor.url[environment] + "/configs",
            method: "POST",
          },
        },
      },
      objects: {
        companyname: {
          name: "companyname",
          initial: "a",
          label: "Company Name",
          helperText: false,
          rules: ["isNotNull"],
        },
        abn: {
          name: "abn",
          initial: "a",
          label: "ABN",
          helperText: false,
          rules: ["isNotNull"],
        },
        firstname: {
          name: "firstname",
          initial: "a",
          label: "First Name",
          helperText: false,
          rules: ["isNotNull"],
        },
        lastname: {
          name: "lastname",
          initial: "a",
          label: "Last Name",
          helperText: false,
          rules: ["isNotNull"],
        },
        contactno: {
          name: "contactno",
          initial: "a",
          label: "Contact No",
          helperText: false,
          rules: ["isNotNull"],
        },
        mobileno: {
          name: "mobileno",
          initial: "a",
          label: "Mobile No",
          helperText: false,
          rules: ["isNotNull"],
        },
        jobtitle: {
          name: "jobtitle",
          initial: "a",
          label: "Job Title",
          helperText: false,
          rules: ["isNotNull"],
        },

        email: {
          name: "email",
          initial: "a",
          label: "Email",
          helperText: false,
          rules: ["isNotNull"],
        },
        password: {
          name: "password",
          initial: "a",
          label: "Password",
          helperText: false,
          rules: ["isNotNull"],
        },
        passwordconfirm: {
          name: "passwordconfirm",
          initial: "a",
          label: "Confirm password",
          helperText: false,
          rules: ["isNotNull", "isConfirm"],
          confirm_to: "password",
          confirm_suffix: "password",
        },

        address1: {
          name: "address1",
          initial: "a",
          label: "Street Number & Name",
          helperText: false,
          rules: ["isNotNull"],
        },
        suburb: {
          name: "suburb",
          initial: "a",
          label: "Suburb",
          helperText: false,
          rules: ["isNotNull"],
        },
        state: {
          name: "state",
          initial: "1",
          type: "select",
          label: "State",
          options: options.preference_options,
          helpText: "Please select a preference",
          rules: ["isNotNull"],
        },
        postcode: {
          name: "postcode",
          initial: "a",
          label: "Post Code",
          helperText: false,
          rules: ["isNotNull"],
        },
      },
      responses: {
        fail: "No such username or password",
        unverified: "Please verify your account by ticking the recaptcha.",
      },
    },
  },
  routes: {
    label: "Register Pop up",
    prefix: "/corporate/register/fail",
  },
  setup,
};

export default config;
